<script>
import format from 'date-fns/format'
import ptBR from 'date-fns/locale/pt-BR'
import { codigoDespesaLabels, codigoDespesaValues } from '@tradimus/api-conciliacao-client'

export default {
  props: {
    faturamentoItems: Array,
    conciliacaoItemsSelected: Array,
    conciliacaoItems: Array,
    noData: Boolean,
    selectedFaturamentoItems: { type: Array, required: true }
  },
  data () {
    return {
      headers: [
        { value: 'classificacao', text: 'Classificação', show: true,  align: 'center'},
        { value: 'codigoProcedimento', text: 'Cód. procedimento', align: 'end', show: true },
        { value: 'descricaoProcedimento', text: 'Desc. procedimento', align: 'start', show: true },
        { value: 'dataExecucao', text: 'Data execução', show: true },
        { value: 'valorInformado', text: 'Valor informado', align: 'end', show: true },
        { value: 'valorPago', text: 'Valor pago', align: 'end', show: true },
        { value: 'valorGlosado', text: 'Valor glosado', align: 'end', show: true },
        { value: 'saldo', text: 'Saldo', align: 'end', show: true },
        { value: 'profissionalExecutante', text: 'Profissional executante', show: true },
        { value: 'quantidade', text: 'Qtd.', show: true },
        { value: 'id', text: 'Id', align: 'end', show: true }
      ],
      detailsOpen: false,
      detailsX: window.innerWidth/2 - 24,
      detailsY: window.innerHeight/2,
      detailsHeaders: [
        { value: 'faturamentoItemId', text: 'Item', align: 'start' },
        { value: 'faturamentoGuiaId', text: 'Guia', align: 'start' },
        { value: 'faturamentoLoteId', text: 'Lote', align: 'start' }
      ],
      icons: {
        checkCircleOutline: 'far fa-check-circle',
        clipBoardClockOutline: 'fa fa-clipboard',
        close: 'fa fa-close'
      },
      detailedItem: {},
      inputFilters: {},
      count: 0,
      itensComGlosa: false,
      conciliacaoDefault: {
        text: 'Todos os itens',
        value: {
          conciliacaoItensCountEq: undefined,
          conciliacaoItensCountGt: undefined
        }
      },
      conciliacaoItensFilter: [
        {
          text: 'Todos os itens',
          value: {
            conciliacaoItensCountEq: undefined,
            conciliacaoItensCountGt: undefined
          }
        },
        {
          text: 'Itens não conciliados',
          value: {
            conciliacaoItensCountEq: 0,
            conciliacaoItensCountGt: undefined
          }
        },
        {
          text: 'Itens conciliados',
          value: {
            conciliacaoItensCountEq: undefined,
            conciliacaoItensCountGt: 0
          }
        }
      ],
      filterConciliacaoItem: false,
      sortingColumnsValues: [
        { text: 'Valor Informado', value: 'valor' },
        { text: 'Valor unitário', value: 'valorUnitario' },
        { text: 'Valor pago', value: 'valorPago' },
        { text: 'Data execução', value: 'dataExecucao' },
        { text: 'Código procedimento', value: 'codigoProcedimento' },
        { text: 'Descrição procedimento', value: 'descricaoProcedimento' },
        { text: 'Quantidade', value: 'quantidade' }
      ],
      sortingOrderValues: [
        { text: 'Crescente', value: 'asc' },
        { text: 'Decrescente', value: 'desc' }
      ],
      sortingQuery: [{ value: '', direction: 'asc' }],
      itensComSaldo: false,
      codigosDespesa: [
        { text: 'Não informado', value: 'naoInformado' },
        ...codigoDespesaValues.map(codigo => ({ text: codigoDespesaLabels[codigo], value: codigo }))
      ],
      codigoDespesa: ''
    }
  },
  methods: {
    handleRowClick (item, itemData, event) {
      if (item.faturamentoEquipes?.length > 0 || item.conciliacaoItens?.length > 0) {
        event.preventDefault()
        this.detailsOpen = false
        this.detailedItem = item

        setTimeout(() => { this.detailsOpen = true }, 25)
      }
    },
    updateCount () {
      this.count = Object.values(this.inputFilters)
        .filter(value => Boolean(value))
        .length
    },
    handleClearFilter () {
      this.inputFilters = {}
      this.itensComGlosa = false
      this.itensComSaldo = false
      this.updateCount()
      this.$emit('faturamentoItemFilterChange', this.inputFilters)
    },
    debouncedFilterChange (key, value) {
      this.$emit('selectedFaturamentoItensChange', [])

      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        this.inputFilters[key] = value
        this.updateCount()
        this.$emit('faturamentoItemFilterChange', this.inputFilters)
      }, 500)
    },
    handleConciliacaoItensChange (value) {
      this.$emit('selectedPagamentoItensChange', [])
      if (value !== null) {
        const filter = this.inputFilters
        this.inputFilters = {
          ...filter,
          ...value
        }

        if (!this.filterConciliacaoItem) {
          this.count++
        }

        this.filterConciliacaoItem = true
        this.$emit('faturamentoItemFilterChange', this.inputFilters)
      } else {
        const filter = this.inputFilters
        this.inputFilters = {
          ...filter,
          conciliacaoItensCountEq: undefined,
          conciliacaoItensCountGt: undefined
        }
        this.conciliacaoDefault = {
          text: 'Todos os itens',
          value: {
            conciliacaoItensCountEq: undefined,
            conciliacaoItensCountGt: undefined
          }
        }
        this.filterConciliacaoItem = false
        this.count--
        this.$emit('faturamentoItemFilterChange', this.inputFilters)
      }
    },
    cleanSort () {
      this.sortingQuery = [{ value: null, direction: 'asc' }]

      this.$emit('faturamentoItemOrderQueryChange', this.sortingQuery)
    },
    addNewSort () {
      this.sortingQuery.push({
        value: null,
        direction: 'asc'
      })
    },
    removeSort (index) {
      this.sortingQuery.splice(index, 1)

      this.$emit('faturamentoItemOrderQueryChange', this.sortingQuery)
    },
    updateSortValue (index, newValue) {
      this.sortingQuery[index].value = newValue

      this.$emit('faturamentoItemOrderQueryChange', this.sortingQuery)
    },
    updateSortDirection (index, newDirection) {
      this.sortingQuery[index].direction = newDirection

      this.$emit('faturamentoItemOrderQueryChange', this.sortingQuery)
    },
    handleDesconciliarClick () {
      if(this.pagamentoItemIds.length === 0) {
        const paramModal = {
          type: "warning",
          title: "Desconciliar itens",
          message: "Não é possível desconciliar itens não conciliados",
          btConfirm: { name: "Ok", show: true }
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        const query = {
          pagamentoItemIds: this.pagamentoItemIds
        }
        this.$emit('clickDesconciliar', query)
      }
    },
    itemConciliadoChip (faturamentoItemId) {
      const indexes = this.conciliacaoItemsSelected
        ?.filter(conciliacaoItemSelected => conciliacaoItemSelected.faturamentoItemsId
        .includes(faturamentoItemId))
        .map(conciliacaoItem => conciliacaoItem.index + 1)

      return indexes?.join(', ') || ''
    }
  },
  computed: {
    noDataText () {
      return this.noData ? 'Nenhuma guia de faturamento selecionada' : 'Não há dados disponíveis'
    },
    computedSelectedFaturamentoItems: {
      get () {
        return this.$props.selectedFaturamentoItems
      },
      set (value) {
        this.$emit('selectedFaturamentoItemsChange', value)
      }
    },
    showBadge () {
      return this.count > 0
    },
    showSortBadge () {
      return this.sortCount > 0
    },
    sortCount () {
      return  this.sortingQuery
        .filter(sort => Boolean(sort.value))
        .length
    },
    codigoProcedimentoList () {
      return [...new Set(this.faturamentoItems.map(faturamentoItem => faturamentoItem.codigoProcedimento).filter(codigoProcedimento => codigoProcedimento))]
    },
    codigoTabelaList () {
      return [...new Set(this.faturamentoItems.map(faturamentoItem => faturamentoItem.codigoTabela).filter(codigoTabela => codigoTabela))]
    },
    descricaoProcedimentoList () {
      return [...new Set(this.faturamentoItems.map(faturamentoItem => faturamentoItem.descricaoProcedimento).filter(descricaoProcedimento => descricaoProcedimento))]
    },
    quantidadeList () {
      return [...new Set(this.faturamentoItems.map(faturamentoItem => faturamentoItem.quantidade).filter(quantidade => quantidade))]
    },
    valorList () {
      return [...new Set(this.faturamentoItems.map(faturamentoItem => faturamentoItem.valor).filter(valor => valor))]
    },
    valorUnitarioList () {
      return [...new Set(this.faturamentoItems.map(faturamentoItem => faturamentoItem.valorUnitario).filter(valorUnitario => valorUnitario))]
    },
    pagamentoItemIds () {
      return this.$props.conciliacaoItemsSelected
        .map(conciliacaoItem => conciliacaoItem.pagamentoItemsId.flat())
        .flat()
    }
  },
  filters: {
    formatDate (date) {
      if (date?.toString().match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)) {
        const match = date.toString().match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/)

        return `${match[3]}/${match[2]}/${match[1]}`
      }

      return date ? format(new Date(date), 'P', { locale: ptBR }) : '-'
    },
    pluralize (count) {
      if (count === 0) {
        return 'Nenhum item selecionado'
      } else if (count === 1) {
        return '1 item selecionado'
      } else {
        return `${count} itens selecionados`
      }
    }
  },
  created () {
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.detailsOpen = false
      }
    })
  }
}
</script>
<template>
  <div class="datatable-container">
    <div class="d-flex align-center justify-space-around">
      <div style="width: 100%;">
        <h3 class="pl-4">Itens de faturamento</h3>
      </div>
      <div v-if="selectedFaturamentoItems.length > 0" class="primary--text" style="width: 100%;">{{ selectedFaturamentoItems.length | pluralize }} de {{ faturamentoItems.length }}</div>
      <div class="d-flex align-center pr-4" style="column-gap: 16px;">
        <v-menu
          offset-y
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-badge
              :value="showBadge"
              :content="count"
              class="white--text"
              color="primary"
              offset-y="15px"
              offset-x="7px"
            >
              <v-btn v-bind="attrs" v-on="on" class="mt-1" color="primary" x-small outlined>
                <v-icon dense x-small left>fa-filter</v-icon>
                FILTRAR
              </v-btn>
            </v-badge>
          </template>
          <div class="d-flex flex-column px-6 pt-4" style="background-color: white; max-height: 36vh; overflow: auto;">
            <v-autocomplete
              class="py-2"
              :items="codigoProcedimentoList"
              key="codigoProcedimento"
              @input="value => debouncedFilterChange('codigoProcedimento', value)"
              :value="inputFilters['codigoProcedimento']"
              :item-text="item => item"
              item-value="codigoProcedimento"
              :label="'Código procedimento'"
              outlined
              clearable
              dense
              hide-details
            />
            <v-autocomplete
              class="py-2"
              :items="codigoTabelaList"
              key="codigoTabela"
              @input="value => debouncedFilterChange('codigoTabela', value)"
              :value="inputFilters['codigoTabela']"
              :item-text="item => item"
              item-value="codigoTabela"
              :label="'Código tabela'"
              outlined
              clearable
              dense
              hide-details
            />
            <v-autocomplete
              class="py-2"
              :items="descricaoProcedimentoList"
              key="descricaoProcedimento"
              @input="value => debouncedFilterChange('descricaoProcedimento', value)"
              :value="inputFilters['descricaoProcedimento']"
              :item-text="item => item"
              item-value="descricaoProcedimento"
              :label="'Descrição procedimento'"
              outlined
              clearable
              dense
              hide-details
            />
            <v-autocomplete
              class="py-2"
              :items="quantidadeList"
              key="quantidade"
              @input="value => debouncedFilterChange('quantidade', value)"
              :value="inputFilters['quantidade']"
              :item-text="item => item"
              item-value="quantidade"
              :label="'Quantidade'"
              outlined
              clearable
              dense
              hide-details
            />
            <v-autocomplete
              class="py-2"
              :items="valorList"
              key="valor"
              @input="value => debouncedFilterChange('valor', value)"
              :value="inputFilters['valor']"
              :item-text="item => item"
              item-value="valor"
              :label="'Valor'"
              outlined
              clearable
              dense
              hide-details
            />
            <v-autocomplete
              class="py-2"
              :items="valorUnitarioList"
              key="valorUnitario"
              @input="value => debouncedFilterChange('valorUnitario', value)"
              :value="inputFilters['valorUnitario']"
              :item-text="item => item"
              item-value="valorUnitario"
              :label="'Valor unitario'"
              outlined
              clearable
              dense
              hide-details
            />
            <v-select
              class="pt-2 pb-4"
              :items="codigosDespesa"
              v-model="codigoDespesa"
              @input="() => debouncedFilterChange('codigoDespesa', codigoDespesa)"
              label="Código despesa"
              outlined
              clearable
              dense
              hide-details
            />
            <v-select
              v-model="conciliacaoDefault"
              :items="conciliacaoItensFilter"
              @input="value => handleConciliacaoItensChange(value)"
              clearable
              :style="'width: 240px'"
              :label="'Itens'"
              outlined
              dense
              hide-details
            />
            <v-checkbox
              v-model="itensComGlosa"
              @change="() => debouncedFilterChange('onlyPositiveValorGlosado', itensComGlosa)"
              :label="'Apenas itens com glosa.'"
            ></v-checkbox>
            <v-checkbox
              v-model="itensComSaldo"
              @change="() => debouncedFilterChange('onlyPositiveSaldo', itensComSaldo)"
              :label="'Apenas itens com saldo.'"
            ></v-checkbox>
            <div style="display: flex; justify-content: end; background-color: #FFF; padding-bottom: 8px;">
              <v-btn
                @click="handleClearFilter"
                color="primary"
                text
                x-small
              >
                Limpar
              </v-btn>
            </div>
          </div>
        </v-menu>
        <v-menu
          :close-on-content-click="false"
          offset-y
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-badge
              :value="showSortBadge"
              :content="sortCount"
              class="white--text"
              color="primary"
              offset-y="15px"
              offset-x="7px"
            >
              <v-btn v-bind="attrs" v-on="on" color="primary" class="mt-1" x-small outlined>
                <v-icon dense x-small left>fa-sort-amount-down</v-icon>
                Ordenar
              </v-btn>
            </v-badge>
          </template>
          <div style="background-color: #FFF;">
            <v-list>
              <v-list-item
                v-for="(sort, index) in sortingQuery"
                :key="index"
              >
                <div class="d-flex align-center">
                  <v-select
                    @change="event => updateSortValue(index, event)"
                    :items="sortingColumnsValues"
                    :value="sort.value"
                    :style="'width: 240px'"
                    class="mr-2"
                    outlined
                    dense
                    hide-details
                  />
                  <v-select
                    @change="event => updateSortDirection(index, event)"
                    :items="sortingOrderValues"
                    :value="sort.direction"
                    :style="'width: 152px'"
                    class="mr-2"
                    outlined
                    dense
                    hide-details
                  />
                  <v-btn
                    v-if="sortingQuery.length > 1"
                    @click="() => removeSort(index)"
                    icon
                  >
                    <v-icon color="primary">mdi-minus-circle</v-icon>
                  </v-btn>
                </div>
              </v-list-item>
            </v-list>
            <v-btn
              @click="addNewSort"
              color="primary"
              class="ml-4 mr-1 mb-4"
              rounded
              x-small
            >
              Adicionar
            </v-btn>
            <v-btn
              @click="cleanSort"
              color="primary"
              outlined
              x-small
              rounded
              class="mb-4"
            >
              Limpar
            </v-btn>
          </div>
        </v-menu>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      :height="'calc(50vh - 90px)'"
      fixed-header
      :items="faturamentoItems"
      :loading-text="'Carregando...'"
      :footer-props="{
        'items-per-page-options': [10, 25, 50]
      }"
      item-key="id"
      class="text-no-wrap"
      dense
      disable-sort
      :disable-pagination="true"
      :hide-default-footer="true"
      show-select
      v-model="computedSelectedFaturamentoItems"
      :no-data-text="noDataText"
    >
      <template v-slot:item.classificacao="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-chip :color="item.conciliado ? 'success' : 'error'" x-small class="ma-1 pa-1" v-on="on">
              {{ item.conciliado ? 'CO' : 'NC' }}
            </v-chip>
          </template>
          <span>{{ item.conciliado ? 'Conciliado' : 'Não conciliado' }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.profissionalExecutante="{ item }">
        <div class="d-flex flex-column">
          <div class="text-body-2">{{ item.faturamentoEquipes[0]?.profissionalNome }}</div>
          <div class="caption">{{ item.faturamentoEquipes[0]?.profissionalCodigo || '-' }}</div>
        </div>
      </template>

      <template v-slot:item.dataExecucao="{ item }">
        {{ item.dataExecucao | formatDate }}
      </template>

      <template v-slot:item.saldo="{ item }">
        {{ item.saldo | formatPrice }}
      </template>

      <template v-slot:item.valorInformado="{ item }">
        {{ item.valor | formatPrice }}
      </template>

      <template v-slot:item.valorProcessado="{ item }">
        {{ item.valorProcessado | formatPrice }}
      </template>

      <template v-slot:item.valorPago="{ item }">
        {{ item.valorPago | formatPrice }}
      </template>

      <template v-slot:item.valorGlosado="{ item }">
        {{ item.valorGlosado | formatPrice }}
      </template>

      <template v-slot:item.descricaoProcedimento="{ item }">
        <v-tooltip bottom :disabled="item.descricaoProcedimento.length <= 30">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              {{ item.descricaoProcedimento.slice(0, 30) }}
              {{ item.descricaoProcedimento.length > 30 ? '...' : ''}}
            </div>
          </template>
          {{ item.descricaoProcedimento }}
        </v-tooltip>
      </template>
    </v-data-table>
    <v-menu
      v-model="detailsOpen"
      :position-x="detailsX"
      :position-y="detailsY"
      absolute
      top
      right
      :close-on-content-click="false"
      :close-on-click="false"
    >
      <v-card style="padding: 16px;">
        <v-btn
          icon
          x-small
          @click="() => detailsOpen = false"
          style="float: right; bottom: 10px; left: 8px;"
        >
          <v-icon>{{ icons.close }}</v-icon>
        </v-btn>

        <div style="padding-bottom: 16px;" v-if="detailedItem.faturamentoEquipes?.length > 0">
          <b>Profissional executante:</b>
          <ul>
            <li v-for="membro in detailedItem.faturamentoEquipes" :key="membro">{{ membro.profissionalNome }}</li>
          </ul>
        </div>

        <div v-if="detailedItem.conciliacaoItens?.length > 0">
          <b>Itens de pagamento conciliados:</b>
          <v-data-table
            fixed-header
            :headers="detailsHeaders"
            :items="detailedItem.conciliacaoItens"
            :loading-text="'Carregando...'"
            item-key="id"
            class="text-no-wrap"
            dense
            disable-sort
            :disable-pagination="true"
            :hide-default-footer="true"
          />
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<style scoped>
.datatable-container {
  border: 1px solid rgb(204, 204, 204);
}
</style>
